import {NaniumObject, RequestType, Type} from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import {News} from "../../entities/news.entity";

export class NewsQueryPaginatedRequestBody extends NaniumObject<NewsQueryPaginatedRequestBody> {
	@Type(Number) page: number;
	@Type(Number) pageSize: number;
	@Type(Object) filter?: any;
	@Type(Boolean) includeAnalytics?: boolean;
	// sort by datePublished (fallback dateCreated) desc instead of dateCreated desc,
	// so paginated lists are monotonic w.r.t. the publish date (facility news tab)
	@Type(Boolean) sortByPublishedDate?: boolean;
}

export class NewsQueryPaginatedResponse extends NaniumObject<NewsQueryPaginatedResponse> {
	@Type(Array, News) newsList: News[];
	@Type(Number) totalCount: number;
	@Type(Number) pageCount: number;
	@Type(Number) pageSize: number;
	@Type(Number) currentPage: number;
}

@RequestType({
	responseType: NewsQueryPaginatedResponse,
	genericTypes: { TRequestBody: NewsQueryPaginatedRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class NewsQueryPaginatedRequest extends ServiceRequestBase<NewsQueryPaginatedRequestBody, NewsQueryPaginatedResponse> {
	static serviceName: string = 'NaniumDemo:news/queryPaginated';
}
